"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiTypography = void 0;
exports.MuiTypography = {
    defaultProps: {
        variantMapping: {
            h1Light: "h1",
            h2Light: "h2",
            h3Light: "h3",
            article: "p",
            articleLight: "p",
            regular16: "span",
            regular14: "span",
            regular12: "span",
        },
    },
};
//# sourceMappingURL=typography.js.map